/**
 * Мультиязычность: словари и хелперы.
 * Подключение: import { LOCALES, getT } from './locales'
 * Использование: const t = getT(locale); t('filters_price'); t.opt(canonicalValue)
 * В API всегда отправляются канонические значения (как в БД), отображение — по выбранному языку.
 */
import ru from './ru'
import uz from './uz'
import oz from './oz'
import en from './en'
import ruOpt from './opt/ru'
import uzOpt from './opt/uz'
import ozOpt from './opt/oz'
import enOpt from './opt/en'

const messages = {
  ru: { ...ru, opt: ruOpt },
  uz: { ...uz, opt: uzOpt },
  oz: { ...oz, opt: ozOpt },
  en: { ...en, opt: enOpt },
}

export const LOCALES = [
  { code: 'ru', name: 'Ру' },
  { code: 'uz', name: 'Уз' },
  { code: 'oz', name: "O'z" },
  { code: 'en', name: 'En' },
]

const DEFAULT_LOCALE = 'ru'
const missingKeys = new Set()
const missingOpt = new Set()

/**
 * Язык по умолчанию по настройкам браузера.
 * ru → ru, уз (uz/uz-Cyrl) → uz, o'z (uz-Latn) → oz, en или другой → en.
 */
export function getBrowserDefaultLocale() {
  if (typeof navigator === 'undefined' || !navigator.language) return DEFAULT_LOCALE
  const raw = (navigator.languages && navigator.languages[0]) || navigator.language || ''
  const lang = String(raw).toLowerCase().split(/[-_]/)[0]
  const full = String(raw).toLowerCase()
  if (lang === 'ru') return 'ru'
  if (lang === 'en') return 'en'
  if (lang === 'uz') {
    if (full.includes('latn')) return 'oz'
    return 'uz'
  }
  return 'en'
}

function warnOnce(set, text) {
  if (process.env.NODE_ENV === 'production') return
  if (set.has(text)) return
  set.add(text)
  // eslint-disable-next-line no-console
  console.warn(text)
}

function capitalizeFirst(str) {
  if (str == null || str === '') return str
  const s = String(str)
  return s.charAt(0).toUpperCase() + s.slice(1)
}

/**
 * Возвращает функцию перевода t и t.opt для текущей локали.
 * @param {string} locale - код языка (ru, uz, oz, en)
 * @returns {{ t: (key: string) => string, opt: (canonical: string) => string }}
 */
export function getT(locale) {
  const loc = locale && messages[locale] ? locale : DEFAULT_LOCALE
  const m = messages[loc] || messages[DEFAULT_LOCALE]

  const t = (key) => {
    if (key == null || key === '') return ''
    const val = m[key]
    if (val !== undefined && val !== null) return String(val)
    warnOnce(missingKeys, `[i18n] Missing key "${key}" for locale "${loc}"`)
    return key
  }

  t.opt = (canonical) => {
    if (canonical == null || canonical === '') return ''
    const c = String(canonical).trim()
    if (!c) return ''
    const val = m.opt && m.opt[c]
    if (val !== undefined && val !== null) return String(val)
    warnOnce(missingOpt, `[i18n] Missing opt "${c}" for locale "${loc}"`)
    return capitalizeFirst(c)
  }

  return t
}

export function getStoredLocale() {
  try {
    const s = localStorage.getItem('realty-map-locale')
    if (s && messages[s]) return s
  } catch (_) {}
  return getBrowserDefaultLocale()
}

export function setStoredLocale(code) {
  try {
    localStorage.setItem('realty-map-locale', code)
  } catch (_) {}
}
